var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-sm-12" }, [
      _c(
        "form",
        {
          attrs: {
            autocomplete: "off",
            method: "post",
            disabled: _vm.loading,
            "data-vv-scope": "form",
          },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.onBeforeSaveItem.apply(null, arguments)
            },
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onBeforeSaveItem.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-sm-auto" }, [
              _c("h1", { staticClass: "content-title" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.titleItem) +
                    "\n                    "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        disabled: _vm.readonlyFormItem,
                        id: "input-status",
                        name: "status",
                        label: "name",
                        filterable: true,
                        options: _vm.lists.onoff,
                        reduce: (option) => option.code,
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("status") },
                        ],
                        error: _vm.fnFirstError("status"),
                        helpText: `${this.pageID}.help.status`,
                      },
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "status",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.status",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.pageID}.model.status`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|integer|min_value:1",
                          expression: "'required|integer|min_value:1'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        type: "number",
                        id: "input-order",
                        name: "order",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("order") },
                        ],
                        error: _vm.fnFirstError("order"),
                        helpText: `${this.pageID}.help.order`,
                      },
                      model: {
                        value: _vm.form.order,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "order",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.order",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.pageID}.model.order`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.isItem
              ? _c("div", { staticClass: "col-sm-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: _vm.isItem },
                              expression: "{required: isItem}",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-regulation_id",
                            name: "regulation_id",
                            label: "name",
                            filterable: true,
                            options: _vm.lists.groups,
                            indentText: true,
                            indentationTarget: "regulation_id",
                            inputClasses: [
                              { "is-invalid": _vm.fnHasError("regulation_id") },
                            ],
                            error: _vm.fnFirstError("regulation_id"),
                            helpText: `${this.pageID}.help.group`,
                          },
                          model: {
                            value: _vm.form.regulation_id,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "regulation_id",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.regulation_id",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(`${_vm.pageID}.model.regulation_id`)
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:3",
                          expression: "'required|min:3'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-name",
                        name: "name",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("name") },
                        ],
                        error: _vm.fnFirstError("name"),
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "name",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.name",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.pageID}.model.name`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.isItem
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("h6", { staticClass: "font-weight-normal" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$t(`${_vm.pageID}.form.document.title`)
                            ) +
                            "\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("hr", { staticClass: "mt-2" }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "MaterialInput",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "url",
                                  expression: "'url'",
                                },
                              ],
                              staticClass: "city-form-group city-bg",
                              attrs: {
                                readonly: _vm.readonlyFormItem,
                                type: "text",
                                id: "input-url",
                                name: "url",
                                inputClasses: [
                                  { "is-invalid": _vm.fnHasError("url") },
                                ],
                                error: _vm.fnFirstError("url"),
                                helpText: `${this.pageID}.help.url`,
                              },
                              model: {
                                value: _vm.form.url,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "url",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.url",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t(`${_vm.pageID}.model.url`)) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "doc" },
                        [
                          _c("upload-multiple-file", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "",
                                expression: "''",
                              },
                            ],
                            staticClass: "mb-0",
                            attrs: {
                              disabled: _vm.readonlyFormItem,
                              name: "filename",
                              acceptTypes: _vm.acceptTypes,
                              maxFiles: _vm.maxFiles,
                            },
                            model: {
                              value: _vm.filename,
                              callback: function ($$v) {
                                _vm.filename = $$v
                              },
                              expression: "filename",
                            },
                          }),
                          _vm._v(" "),
                          _c("help-span", {
                            attrs: { helpText: `${this.pageID}.help.upload` },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("buttons-footer", {
            attrs: {
              enableButtons: !_vm.readonlyFormItem,
              cancelTitle: _vm.cancelTitle,
              submitTitle: _vm.submitTitle,
              isDisabled: _vm.isDisabled,
            },
            on: {
              save: _vm.onBeforeSaveItem,
              cancel: function ($event) {
                return _vm.handleBack(`${_vm.moduleCode}.${_vm.pageID}`, true)
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }